module.exports = __webpack_public_path__ + "static/media/uruguay.ddb48d04.svg";